import EditContactSkeleton from '@Components/General/Skeletons/edit-contact';
import { createFileRoute } from '@tanstack/react-router';
import { contactQueryOptions } from '@utils/queryOptions';
import EditContact from '@Views/Contacts/Contacts/EditContact';

export const Route = createFileRoute('/contacts/$contactId/edit')({
    component: EditContact,
    loader: opts =>
        opts.context.queryClient.ensureQueryData(
            contactQueryOptions(opts.params.contactId),
        ),
    pendingComponent: EditContactSkeleton,
});
